import { Locale } from 'modules/i18n';

export const connectWalletButtonTranslation = {
  [Locale.en]: {
    connectWallet: 'Connect wallet to proceed',
  },
};
